import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { of } from 'rxjs';
import { flatMap, shareReplay } from 'rxjs/operators';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { ClassroomService } from 'src/app/_services/classroom.service';
import { MetaFormDialogComponent } from '../meta-form-dialog/meta-form-dialog.component';
import { UnidadEtapasService } from '../unidad-etapas/_services/unidad-etapas.service';
import * as moment from 'moment';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MY_FORMATS } from 'src/app/_models/moment-formats';

@Component({
  selector: 'app-unidad-evento-classroom-mcp',
  standalone: false,
  templateUrl: './unidad-evento-classroom-mcp.component.html',
  styleUrls: ['./unidad-evento-classroom-mcp.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class UnidadEventoClassroomMcpComponent implements OnInit {

  @Input()
  eventoMateria;

  materiaPeriodo;
  tareas;

  @Output()
  guardarEvent: EventEmitter<any>;
  @Output()
  cerrarEvent: EventEmitter<any>;

  date = new UntypedFormControl('');

  constructor(
    private classroomService: ClassroomService,
    public dialogRef: MatDialogRef<MetaFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private unidadEtapasService: UnidadEtapasService,
    private customAlertService: CustomAlertService,
    private snackBar: MatSnackBar
  ) {
    this.guardarEvent = new EventEmitter();
    this.cerrarEvent = new EventEmitter();
    this.eventoMateria = this.data.eventoMateria;
    this.date.setValue(moment(this.eventoMateria.fechaAplicar).format('YYYY-MM-DD'));
    this.tareas = this.data.tareas;
  }

  ngOnInit(): void {
  }

  guardarMCP() {
    this.eventoMateria.fechaAplicar = this.date.value;
    this.unidadEtapasService.guardarMCP(this.eventoMateria).subscribe(res => {
      this.unidadEtapasService.actualizarObjeto('evento-calendario-unidad', this.eventoMateria);
      this.snackBar.open(`El evento se ha actualizado satisfactoriamente.`, null, {
        duration: 3000
      });
      this.dialogRef.close();
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `Error al actualizar el evento. ${err.error} Codigo: ${err.statusText}`
      });
    });
  }

}
